<template>
    <div class="container-fluid container">
        <form class="container-fluid">
            <h1 class="fw-bold">Login</h1>
            <p class="text-muted register-text">Don't have an Account?<button type="button" class="btn btn-link" @click="RegisterRoute()">Register</button></p>
            <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">Email address</label>
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" required v-model="email">
                <div id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</div>
            </div>
            <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">Password</label>
                <input type="password" class="form-control" id="exampleInputPassword1" required v-model="password">
            </div>
            <button type="submit" class="btn btn-primary" @click.prevent="login()">Login</button>
        </form>
    </div>

</template>

<script>
import axios from 'axios';

export default{
    name: 'UserLogin',
    methods: {
        RegisterRoute(){
            this.$router.push('/register');
        },
        login() {
            let user = {
                email: this.email,
                password: this.password
            }
            axios.post('https://mydropuser.onrender.com/login/', user)
            .then(res => {
                if(res.status === 200) {
                    localStorage.setItem('token', res.data.token);
                    this.$router.push('/account');
                }
            })
            .catch(err => {
                if(err.response.status === 379) {
                    alert('Error');
                } else {
                    alert('Something went wrong');
                }
            })
        }
    },
    data() {
        return {
            email: '',
            password: '',
        }
    },
    mounted() {
        if(localStorage.getItem('token')) {
            this.$router.push('/account');
        }
    }
}
</script>

<style scoped lang="scss">
.container{
    min-width: 30%;
    width: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    justify-self: center;
    text-align: left;
}

.mb-3{
    text-align: left;

    label{
        margin-bottom: .2rem;
    }

    #emailHelp{
        margin-top: .2rem;
    }
}

.register-text{
    margin-bottom: 2rem;
}
</style>